export default __webpack_public_path__ + "static/media/puutarha_3.51fc02a7.jpg";